module.exports = __webpack_public_path__ + "static/media/permits-icon.524af788.svg";